import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ================= DATA ================= */
const DEFAULT_RACING_GAMES = [
  { id: 1, title: "Gear Madness", image: "/assets/gamescard/gear-madness.png", link: "http://ghanagameium.com/gear-madness/" },
  { id: 2, title: "Traffic Racer", image: "/assets/gamescard/traffic-racer.png", link: "http://ghanagameium.com/traffic-racer/" },
  { id: 3, title: "Aero Rush", image: "/assets/gamescard/aero-rush.png" },
  { id: 4, title: "Formula Rush", image: "/assets/gamescard/formula-rush.png", link: "http://ghanagameium.com/formula-racing/" },
  { id: 5, title: "Roadmash Car", image: "/assets/gamescard/roadmash22.png", link: "http://ghanagameium.com/roadmash-car/" },
  { id: 6, title: "Fastlanego", image: "/assets/gamescard/fast-lane.png" },
];

const RacingGames = () => {
  const navigate = useNavigate();

 const handleGameClick = (game) => {
  const isSubscribed = localStorage.getItem("isSubscribed") === "true";

  if (!isSubscribed) {
    Swal.fire({
      title: "🚫 Subscription Required",
      text: "Please subscribe to play games",
      icon: "warning",
      confirmButtonColor: "#ff003c",
      confirmButtonText: "Go to Subscribe",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/signin");
      }
    });
    return;
  }

  if (game.link) {
    window.open(game.link, "_self");
  } else {
    navigate("/games");
  }
};

  return (
    <div className="relative overflow-hidden mt-5">

      {/* 🔥 LIGHT GLOW BACKGROUND */}
      <div className="absolute left-[-180px] top-[20px] w-[350px] h-[350px] rounded-full 
      bg-gradient-to-br from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[100px] pointer-events-none"></div>

      <div className="absolute right-[-150px] bottom-[0px] w-[300px] h-[300px] rounded-full 
      bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[120px] pointer-events-none"></div>

      {/* CONTENT */}
      <div className="relative z-10 w-full py-10 px-4">
        <div className="max-w-6xl mx-auto">

          {/* HEADER */}
          <div className="flex flex-wrap justify-between items-center mb-8 gap-4">
            <h2 className="text-white text-3xl font-bold">
              <span className="text-[#ff003c]">Racing</span> Games
            </h2>

            <div className="flex items-center gap-3">

              {/* VIEW ALL */}
              <button
                onClick={() => navigate("/games")}
                className="px-5 py-2 rounded-lg text-white font-semibold 
                bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
                hover:scale-105 transition-all duration-300"
              >
                View All
              </button>

              {/* ARROWS */}
              <button className="swiper-button-prev-racing w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowBack className="text-white" />
              </button>

              <button className="swiper-button-next-racing w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowForward className="text-white" />
              </button>

            </div>
          </div>

          {/* SLIDER */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-racing",
              nextEl: ".swiper-button-next-racing",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {DEFAULT_RACING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  className="group cursor-pointer flex flex-col h-full"
                  onClick={() => handleGameClick(game)}
                >

                  {/* CARD */}
                  <div className="rounded-xl border border-[#ff003c]/20 
                  bg-[#141422] overflow-hidden
                  shadow-[0_10px_20px_rgba(255,0,60,0.1)]
                  hover:border-[#ff003c] 
                  hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
                  transition-all duration-300">

                    {/* IMAGE FIX 🔥 */}
                    <div className="w-full h-[160px] sm:h-[200px] md:h-[220px] overflow-hidden">
                      <img
                        src={game.image}
                        alt={game.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  </div>

                  {/* TITLE */}
                  <h3 className="text-white text-sm sm:text-base md:text-lg font-semibold mt-4 text-center group-hover:text-[#ff003c] transition">
                    {game.title}
                  </h3>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
};

export default RacingGames;